export enum AuthReduxActions {
    AUTH_SET_LOGIN_STATUS = 'AUTH_SET_LOGIN_STATUS',
    SESION_EXPIRED_LOGOUT = 'SESSION_EXPIRED_LOGOUT',
    IDLECHECK_EXPIRED_LOGOUT = 'IDLECHECK_EXPIRED_LOGOUT',
    RESET_LOGOUT_FIELD = 'RESET_LOGOUT_FIELD',
    RESET_LOGGING_IN = 'RESET_LOGGING_IN',
    AUTH_SET_UPDATE_STATUS = 'AUTH_SET_UPDATE_STATUS',
    LOGOUT = 'LOGOUT',
    REFRESH_TOKEN = 'REFRESH_TOKEN',
}

const setLoginStatus = (payload: any): any => ({
    type: AuthReduxActions.AUTH_SET_LOGIN_STATUS,
    payload,
});

const updateLoginStatus = (payload: any): any => ({
    type: AuthReduxActions.AUTH_SET_UPDATE_STATUS,
    payload,
});
const resetFieldLoggingOut = (payload: any): any => ({
    type: AuthReduxActions.RESET_LOGOUT_FIELD,
    payload,
});
const resetFieldLoggingIn = (payload: any): any => ({
    type: AuthReduxActions.RESET_LOGGING_IN,
    payload,
});
const doLogout = (payload: any): any => ({
    type: AuthReduxActions.LOGOUT,
    payload,
});
const doExpirityLogout = (payload: any): any => ({
    type: AuthReduxActions.SESION_EXPIRED_LOGOUT,
    payload,
});

const doLogoutAfterIdleCheck = (payload: any): any => ({
    type: AuthReduxActions.IDLECHECK_EXPIRED_LOGOUT,
    payload,
});

const forceRefreshToken = (payload: any): any => ({
    type: AuthReduxActions.REFRESH_TOKEN,
    payload,
});

export const AuthActions = {
    resetFieldLoggingOut,
    resetFieldLoggingIn,
    setLoginStatus,
    doLogout,
    doExpirityLogout,
    doLogoutAfterIdleCheck,
    updateLoginStatus,
    forceRefreshToken,
};
